import { PagePartComponent } from "@/model/Enums";

module PagePartList {

    export interface IPagePartListItem {
        component: PagePartComponent;
        title: string;
        description: string;
        image: string;
    }

    export const list: Array<IPagePartListItem> = [{
            component: PagePartComponent.Text,
            title: "Text Part",
            description: "Formatted text only without any images or other embilishements.",
            image: "page-part-text.png"
        }, {
            component: PagePartComponent.Note,
            title: "Note Part",
            description: "An information, comment, warning or action box.",
            image: "page-part-note.png"
        }, {
            component: PagePartComponent.Map,
            title: "Map Part",
            description: "A location map (Open Street Maps)",
            image: "page-part-map.png"
        }, {
            component: PagePartComponent.ResourceAndText,
            title: "Resource with Text",
            description: "Formatted text along with an image, video or audio.",
            image: "page-part-text-resource.png"
        }, {
            component: PagePartComponent.RadioChoice,
            title: "Radio-Button Choice",
            description: "Multiple choice question.  Use this when there is ONE correct choice.",
            image: "page-part-radio-button.png"
        }, {
            component: PagePartComponent.CheckboxChoices,
            title: "Checkbox Choices",
            description: "Multiple choice question.  Use this when there are MULTIPLE correct choices, e.g., 'tick all that apply'.",
            image: "page-part-check-box.png"
        }, {
            component: PagePartComponent.FreeText,
            title: "Free Text Entry",
            description: "The respondent can enter anything they like.",
            image: "page-part-free-text.png"
        }, {
            component: PagePartComponent.Download,
            title: "File Download",
            description: "For providing extra information via PDFs, etc.",
            image: "page-part-download.png"
        }, {
            component: PagePartComponent.PhotoCapture,
            title: "Photo Capture",
            description: "For the respondent to prove their identity.",
            image: "page-part-photo.png"
        }, {
            component: PagePartComponent.ConfirmToContinue,
            title: "Confirm to Continue",
            description: "Require confirmation or agreement from respondant to carry on.",
            image: "page-part-confirm.png"
        },{
            component: PagePartComponent.PasscodeToContinue,
            title: "Passcode to Continue",
            description: "Require a pre-arranged code to be entered to carry on.",
            image: "page-part-passcode.png"
        },{
            component: PagePartComponent.None,
            title: "A page part",
            description: "This is the default.  You probably shouldn't be seeing this!",
            image: "page-part-empty.png"
        }
    ];

    export const getTitle = (component: PagePartComponent): string =>  PagePartList.list.find(i => i.component === component)?.title ?? "(not found)";
}

export default PagePartList;